import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setWhyStoppedMedication as updateWhyStoppedMedication } from "../../redux/userSlice";
import Question from "../../components/Question";
import { Box, FormControlLabel, FormControl, Checkbox, useTheme } from "@mui/material";
import ContinueButton from "../../components/ContinueButton";
import { checkboxSx, continueButtonSx } from "../../lib/uiformatting";
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function StoppedMedication() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const theme = useTheme();

    const options = {
        "It did not work for me": "It did not work for me",
        "I had some side effects": "I had some side effects",
        "I was instructed only to take it for a short time": "I was instructed only to take it for a short time",
    };

    const user = useSelector((state) => state.user);
    const [whyStoppedMedication, setWhyStoppedMedication] = useState([]);

    useEffect(() => {
        const stoppedArray = Array.isArray(user.whyStoppedMedication)
            ? user.whyStoppedMedication
            : typeof user.whyStoppedMedication === "string"
                ? [user.whyStoppedMedication]
                : [];
        setWhyStoppedMedication(stoppedArray);
    }, [user.whyStoppedMedication]);

    const handleChange = (e) => {
        const { name, checked } = e.target;
        if (checked) {
            setWhyStoppedMedication((prev) => [...prev, name]);
        } else {
            setWhyStoppedMedication((prev) => prev.filter((item) => item !== name));
        }
    };

    const handleNext = () => {
        dispatch(updateWhyStoppedMedication(whyStoppedMedication));
        if (whyStoppedMedication.includes("I had some side effects")) {
            setPageAndDeferNavigate(dispatch, '/describe-side-effects', navigate);
        } else {
            setPageAndDeferNavigate(dispatch, '/follow-up-care', navigate);
        }
    };

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, '/currently-prescribed', navigate);
    };

    return (
        <Question
            onBack={handleBack}
            returning={true}
            title="Why did you stop this medication?"
            subtitle="You can select multiple responses"
            input={
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
                    <Box sx={{ width: "100%", maxWidth: "400px", [theme.breakpoints.up("sm")]: { margin: "0 auto" } }}>
                        <FormControl sx={{ display: "flex", flexDirection: "column", gap: "1rem", mb: "2rem" }}>
                            {Object.keys(options).map((key) => (
                                <FormControlLabel
                                    key={key}
                                    control={
                                        <Checkbox
                                            checked={whyStoppedMedication.includes(key)}
                                            onChange={handleChange}
                                            name={key}
                                        />
                                    }
                                    label={options[key]}
                                    sx={{ ...checkboxSx }}
                                />
                            ))}
                        </FormControl>
                    </Box>

                </Box>
            }
            footer={
                <Box
                    sx={{ ...continueButtonSx }}
                >
                    <ContinueButton
                        onClick={handleNext}
                        title={whyStoppedMedication.length > 0 ? "Continue" : "None of the above"}
                        selected={whyStoppedMedication.length > 0}
                    />
                </Box>
            }
        />
    );
}